// src/pages/Workers/Expenses/ExportExpensesExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportExpensesExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Expenses");
const t = i18n.t.bind(i18n);

  worksheet.columns = [
    { header: t("reimbursementRequest.tableHeaders.id"), key: "id", width: 8 },
    { header: t("reimbursementRequest.tableHeaders.amount"), key: "amount", width: 15 },
    { header: t("reimbursementRequest.tableHeaders.dateOfExpense"), key: "date", width: 20 },
    { header: t("reimbursementRequest.tableHeaders.description"), key: "description", width: 25 },
    { header: t("reimbursementRequest.tableHeaders.proof"), key: "proof", width: 20 },
    { header: t("reimbursementRequest.tableHeaders.status"), key: "status", width: 15 },
    { header: t("reimbursementRequest.tableHeaders.comments"), key: "comments", width: 25 },
  ];

  worksheet.addRows(data);

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "003149" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  saveAs(blob, `Expenses_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportExpensesExcel;
